import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'
import { usersRoutes } from '../routes'
import { userDatabase } from '../indexedDB'
import { FirmaUsuarioDialog } from '../dialogs'
import { ROLES } from '../config'

export const SignatureContext = createContext()

export const SignatureProvider = ({ children }) => {
    const { userData, setUserData } = useAuth()
    const [openSign, setOpenSign] = useState(false)
    const [refCanvas, setRefCanvas] = useState()
    const [isDraw, setIsDraw] = useState(false)

    useEffect(() => {
        if (userData) {
            const isObserver = userData.role?.dbName === ROLES.OBSERVER
            if (!isObserver && (!userData.sign || userData.sign.length < 1)) {
                setTimeout(() => {
                    setOpenSign(true)
                }, 500)
            }
        }
    }, [userData])

    const saveUserToDb = async (userDataLocal) => {
        const { database } = await userDatabase.initDb()
        await userDatabase.actualizar(userDataLocal, database)
    }

    const setRefCanvasFunction = (ref) => {
        setRefCanvas(ref)
    }

    const clear = () => {
        if (refCanvas) {
            refCanvas.clear()
        }
    }

    const getImage = () => {
        if (isDraw && refCanvas) {
            const signData = refCanvas.toDataURL()
            usersRoutes.createSign(signData).then(async (response) => {
                const userDataTemp = { ...userData, sign: response.data.sign }
                setUserData(userDataTemp)
                saveUserToDb(userDataTemp)
                localStorage.setItem('user', JSON.stringify(userDataTemp))
                setOpenSign(false)
                alert('Muchas gracias. Su firma ha sido actualizada.')
            }).catch(error => {
                console.error('Error saving signature:', error)
                alert('Hubo un error al guardar su firma. Por favor, intente de nuevo.')
            })
        } else {
            alert('Por favor dibuje una firma.')
        }
    }

    const value = {
        openSign,
        setOpenSign,
        setRefCanvasFunction,
        getImage,
        clear,
        setIsDraw
    }

    return (
        <SignatureContext.Provider value={value}>
            {children}
            <FirmaUsuarioDialog
                openSign={openSign}
                setRefCanvasFunction={setRefCanvasFunction}
                getImage={getImage}
                clear={clear}
                setIsDraw={setIsDraw}
            />
        </SignatureContext.Provider>
    )
}

export const useSignature = () => useContext(SignatureContext)
